const proxy = "http://127.0.0.1:5000";

export default {
    proxy
}